import debug from './debug';
import { defineAdSlot } from './utils';

const { gptSlots, targeting, debugMode } = window.mediaPressAdsConfig;

/**
 * Define immediate ad slots based on the configuration.
 *
 * These are the slots that should be defined immediately when the page loads,
 * for example, the slots that are above the fold.
 *
 * @return {void}
 */
export function defineImmediateAdSlots() {
  Object.entries(gptSlots).forEach(([id, slot]) => {
    if (!slot.immediate) {
      return;
    }

    defineAdSlot(id, slot, id);
  });
}

/**
 * Initialize Google Publisher Tags.
 *
 * @return {void}
 */
function initGpt() {
  window.googletag.pubads().enableLazyLoad({
    fetchMarginPercent: 500,
    renderMarginPercent: 10,
    mobileScaling: 2.0,
  });
  window.googletag.pubads().enableSingleRequest();
  window.googletag.pubads().disableInitialLoad();

  if (targeting) {
    Object.entries(targeting).forEach(([key, value]) => {
      window.googletag.pubads().setTargeting(key, value);
    });
  }

  window.googletag.enableServices();

  // Indicate that GPT Initialization is complete.
  window.googletagInitialized = true;
}

window.addEventListener('load', () => {
  if (debugMode) {
    debug();
  }

  defineImmediateAdSlots();
  initGpt();
});
